const styles = (theme) => ({
  root: {
    cursor: "none !important",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    alignSelf: "flex-start",
    marginTop: "8px",
    paddingLeft: "13px",
  },
  noPad: {
    marginRight: 0,
  },
  a: {
    cursor: "none !important",
    color: "inherit",
    textDecoration: "none",
  },
  p: {
    cursor: "none !important",
    color: "black",
    fontFamily: "Aktiv Grotesk",
    fontWeight: "400",
    margin: "0",
    fontSize: "12px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
      textAlign: "left",
      marginTop: "10px",
    },
  },
  checkBoxChecked: {
    cursor: "none !important",
    height: "1rem",
    width: "1rem",
    border: "4px solid #151515",
    outline: "1px solid white",
    backgroundColor: "#FFF",
  },
  checkBoxUncheck: {
    cursor: "none !important",
    height: "1rem",
    width: "1rem",
    outline: "1px solid white",
    border: "1px solid #151515",
  },
  warn: {
    fontFamily: "Aktiv Grotesk",
    margin: "0",
    fontSize: "10px",
    marginTop: "1rem",
    marginLeft: "-5px",
    color: "black",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
      textAlign: "left",
      marginTop: "10px",
    },
  },
});

export default styles;
